<script>
import BaseCard from "../Accommodatie/BaseCard";

export default {
  name: "PasswordResetCard",
  extends: BaseCard,
  props: ["user"],
  data: function () {
    return {
      header: "Wachtwoord opnieuw instellen",
      disabled: false,
      values: {},
      error_msg: null,
    };
  },
  computed: {
    schema: function () {
      return [
        {
          type: "password",
          name: "current_password",
          label: "Huidig wachtwoord",
          placeholder: "",
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "",
        },
        {
          type: "password",
          name: "new_password",
          label: "Nieuw wachtwoord",
          placeholder: "",
          disabled: this.disabled,
          validation: [
            [
              "matches",
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
            ],
            [("confirm", "new_password_control")],
          ],
          "validation-messages": {
            matches:
              "Wachtwoord is moet minimaal 8 karakters lang zijn. En moet minimaal 1 kleine letter, 1 hoofletter, 1 getal en 1 speciaal karakter (!@#$%^&*) bevatten.",
          },
          "input-class": this.disabled ? "disabled" : "",
        },
        {
          type: "password",
          name: "new_password_control",
          label: "Herhaal wachtwoord",
          validation: "^required|confirm:new_password",
          placeholder: "",
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "",
          "validation-messages": {
            required: "Wachtwoord is verplicht",
            confirm: "Wachtwoorden komen niet overeen",
          },
        },

        {
          type: "submit",
          "input-class": ["btn", "btn-blue", this.disabled ? "disabled" : ""],
          label: "Opslaan",
        },
        {
          component: "p",
          children: this.error_msg,
        },
      ];
    },
  },
  methods: {
    submitHandler: async function () {
      this.error_msg = null;
      let response = await this.$store.dispatch("changePassword", {
        new_password: this.values["new_password"],
        current_password: this.values["current_password"],
        user_id: this.$store.getters.current_user["id"],
      });
      if ("error" in response) {
        this.error_msg = "Kan wachtwoord niet instellen. Probeer het nog eens.";
      } else {
        this.error_msg = "Wachtwoord succesvol gewijzigd.";
      }
    },
  },
};
</script>
